(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-columns"] && !Shopify.designMode) return;
  try {
    
  class CarouselGroups extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.carousel-track')
      if (!this.track || this.track.children.length <= 1) return

      this.interval = parseInt(this.dataset.interval, 10) || 5000
      this.startTimer()

      this.prevButton = this.querySelector('.carousel-arrow--prev')
      this.nextButton = this.querySelector('.carousel-arrow--next')

      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => {
          this.prev()
          this.restartTimer()
        })
      }
      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => {
          this.next()
          this.restartTimer()
        })
      }
    }

    disconnectedCallback() {
      clearInterval(this.timer)
    }

    startTimer() {
      this.timer = setInterval(() => this.next(), this.interval)
    }

    restartTimer() {
      clearInterval(this.timer)
      this.startTimer()
    }

    next() {
      const track = this.track
      const itemCount = track.children.length
      const shiftPercent = 100 / itemCount

      const incoming = track.lastElementChild
      track.style.transition = 'none'
      track.insertBefore(incoming, track.firstElementChild)
      track.style.transform = `translateX(-${shiftPercent}%)`

      void track.offsetWidth

      requestAnimationFrame(() => {
        track.style.transition = 'transform 500ms ease'
        track.style.transform = 'translateX(0)'
      })
    }

    prev() {
      const track = this.track
      const itemCount = track.children.length
      const shiftPercent = 100 / itemCount

      const onEnd = () => {
        track.removeEventListener('transitionend', onEnd)
        track.style.transition = 'none'
        track.appendChild(track.firstElementChild)
        track.style.transform = 'translateX(0)'
        void track.offsetWidth
      }
      track.addEventListener('transitionend', onEnd, { once: true })

      track.style.transition = 'transform 500ms ease'
      track.style.transform = `translateX(-${shiftPercent}%)`
    }
  }

  customElements.define('carousel-groups', CarouselGroups)

  } catch(e) { console.error(e); }
})();
})();
